import { formatString, _T } from '../../../include/appI18n';
export const _ParentFrame = () => window.parentIFrame;
export const autocompleteLocalizationProps = {
    clearText: _T.AUTOCOMPLETE_CLEAR,
    closeText: _T.AUTOCOMPLETE_CLOSE,
    getLimitTagsText: (num) => formatString(_T.AUTOCOMPLETE_LIMIT_TAGS, [num]),
    loadingText: _T.AUTOCOMPLETE_LOADING,
    noOptionsText: _T.AUTOCOMPLETE_NO_OPTIONS,
    openText: _T.AUTOCOMPLETE_OPEN,
};
export const iconClasses = { root: 'MuiSvgIcon-root-widget' };
